export const INCOME_REPORT = {
  IncomeSummary: '/report/netincomes',
  IncomeDetails: '/report/netincomes/details',
  ExportIncomeSummary: '/report/netincomes/export',
  ExportIncomeDetails: '/report/netincomes/export-details',
  ReportSummary: '/report/netincomes/report-summary',
  ReportDetails: '/report/netincomes/report-details',
  ReportFullDetails: '/report/netincomes/report-full-details',
};
